import { useProductTour } from '../contexts/ProductTourContext';
import { TOUR_MOCK_DATASET, TOUR_MOCK_LEADS, TOUR_MOCK_COLUMNS } from '../constants/tourMockData';
import { TOUR_SAMPLE_DATA } from '../constants/tour';

export function useTourMockData() {
  const { isActive } = useProductTour();

  return {
    isTourMode: isActive,
    mockDataset: isActive ? TOUR_MOCK_DATASET : null,
    mockLeads: isActive ? TOUR_MOCK_LEADS : null,
    mockColumns: isActive ? TOUR_MOCK_COLUMNS : null,
    tourDatasetId: TOUR_SAMPLE_DATA.datasetId,
  };
}

export function isTourDataset(datasetId: string | undefined): boolean {
  return datasetId === TOUR_SAMPLE_DATA.datasetId;
}
